import { instanceBase as axios } from '../lib/axios';
import { parseDomain } from '../lib/utils';

export const ENTER_EMAIL = 'ENTER_EMAIL';
export const onEnterEmail = (email) => {
    return {
        type: ENTER_EMAIL,
        payload: email,
    };
};

export const ENTER_SUBJECT = 'ENTER_SUBJECT';
export const onEnterSubject = (subject) => {
    return {
        type: ENTER_SUBJECT,
        payload: subject,
    };
};

export const ENTER_MESSAGE = 'ENTER_MESSAGE';
export const onEnterMessage = (message) => {
    return {
        type: ENTER_MESSAGE,
        payload: message,
    };
};

export const SET_RECAPTCHA_TOKEN = 'SET_RECAPTCHA_TOKEN';
export const onSetReCaptcha = (token) => {
    return {
        type: SET_RECAPTCHA_TOKEN,
        payload: token,
    };
};

export const SELECT_FILE = 'SELECT_FILE';
export const onSelectFile = (file) => {
    return {
        type: SELECT_FILE,
        payload: file,
    };
};

export const CLEAR_FORM = 'CLEAR_FORM';
export const clearForm = () => {
    return {
        type: CLEAR_FORM,
    };
};

export const SENDING_REPORT_START = 'SENDING_REPORT_START';
export const SENDING_REPORT_SUCCESS = 'SENDING_REPORT_SUCCESS';
export const SENDING_REPORT_ERROR = 'SENDING_REPORT_ERROR';
export const sendReport = (email, topic, message, token = null, file, logged = false) => {
    return async (dispatch) => {
        dispatch({ type: SENDING_REPORT_START });
        // Controllo dominio

        let fileData = {};
        if (file) {
            fileData = {
                attachBlob: await getFileContent(file),
                attachName: file.name,
                attachType: file.type,
            };
        }

        const data = {
            email: email,
            captchaToken: token,
            message: message,
            type: topic,
            application: `VIEWER - ${parseDomain()}`,
            ...fileData,
        };

        const url = `${logged ? '/email/support' : '/email/anonymousSupport'}`;

        try {
            await axios.post(url, data);
            dispatch({ type: SENDING_REPORT_SUCCESS });
        } catch {
            dispatch({ type: SENDING_REPORT_ERROR });
        }
    };
};

const getFileContent = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (evt) {
            resolve(btoa(evt.target.result));
        };
        reader.onerror = function (err) {
            reject(err);
        };
        reader.readAsBinaryString(file);
    });
};
